import { Column, PageMainContent, Row } from '@/components'
import styled from 'styled-components'

export const ClaimViewPageMainContent = styled(PageMainContent)`
  max-width: 886px;
`

export const ClaimViewContainer = styled(Column)`
  gap: 8px;
  margin-bottom: 48px;
`

export const TitleRow = styled(Row)`
  justify-content: space-between;
  align-items: center;
  gap: 16px;
`

export const CarrierRow = styled(Row)`
  align-items: center;
  gap: 12px;
  padding: 24px 0;
`

export const ClaimDetails = styled(Column)`
  gap: 16px;
  padding-bottom: 24px;
`

export const ClaimDetailRow = styled(Row)`
  justify-content: space-between;
  gap: 16px;

  & span:nth-child(2) {
    text-align: end;
  }
`
